import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=30014827&scoped=true&"
import script from "./CompanyInfo.vue?vue&type=script&lang=js&"
export * from "./CompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInfo.vue?vue&type=style&index=0&id=30014827&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30014827",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30014827')) {
      api.createRecord('30014827', component.options)
    } else {
      api.reload('30014827', component.options)
    }
    module.hot.accept("./CompanyInfo.vue?vue&type=template&id=30014827&scoped=true&", function () {
      api.rerender('30014827', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PersonalCenter/CompanyInfo/CompanyInfo.vue"
export default component.exports